var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"out",class:{max: _vm.progress > 96}},[_c('span',{staticClass:"in",style:({width: _vm.progress + '%'})},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.progress)+"%")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }